export default __webpack_public_path__ + "static/media/proximanova-light.14028f7a.WOFF";